const countList = [
  {
    count: 4,
    desc: "Языка програмирования",
  },
  {
    count: 5,
    desc: "Лет опыта",
  },
  {
    count: 8,
    desc: "Инструментов разработки",
  },
];

export default countList;